'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$31() {
  this.bhR = null;
  this.bhP = null;
  this.bhQ = false;
  this.bhN = null;
  this.bhO = false;
  this.bhS = false;
  this.bhT = false;
  this.bhR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$31 as $c_Lpresto_PrestoRouter$$anon$31 };
$p = $c_Lpresto_PrestoRouter$$anon$31.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$31;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$31() {
}
export { $h_Lpresto_PrestoRouter$$anon$31 as $h_Lpresto_PrestoRouter$$anon$31 };
$h_Lpresto_PrestoRouter$$anon$31.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bhR;
});
$p.t = (function() {
  if ((!this.bhQ)) {
    this.bhP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhQ = true;
  }
  return this.bhP;
});
$p.ag = (function() {
  if ((!this.bhO)) {
    this.bhN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhO = true;
  }
  return this.bhN;
});
$p.v = (function() {
  if ((!this.bhT)) {
    this.bhS = false;
    this.bhT = true;
  }
  return this.bhS;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$31 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$31, "presto.PrestoRouter$$anon$31", ({
  O5: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$31 as $d_Lpresto_PrestoRouter$$anon$31 };
//# sourceMappingURL=presto.-Presto-Router$$anon$31.js.map
